import React from 'react';

import { inject } from '../../../../../../../../../common/container/inject';
import { IRouterService, RouterServiceToken } from '../../../../../../../../../service/route/IRouterService';
import { LayoutNotificationType } from '../../../../../../../../../view/layout/common/notification/store/ILayoutNotification';
import { ILocalization, ILocalizationToken } from '../../../../../../../application/language/ILocalization';
import { ILearningRootService, LearningRootServiceToken } from '../../../../../../../service/LearningRootService';
import { FinalResultsVerbose } from '../../../../../../shared/components/FinalResultsVerbose/FinalResultsVerbose';
import { IFinalResultsValues } from '../models/IFinalResultsValues';
import { IPassingFinalResultsDomain } from './IPassingFinalResultsDomain';
import { PassingFinalResultsUI } from './PassingFinalResultsUI';

const getResultStatus = (value, isPassed) =>
  !isPassed ? 'failure' : value >= 0.7 ? 'success' : value < 0.7 && value >= 0.5 ? 'neutral' : 'failure';

export class PassingFinalResultsDomain implements IPassingFinalResultsDomain {
  constructor(
    public ui = new PassingFinalResultsUI(),
    private router: IRouterService = inject<IRouterService>(RouterServiceToken),
    private learningRootService = inject<ILearningRootService>(LearningRootServiceToken),
    private i18n: ILocalization = inject<ILocalization>(ILocalizationToken),
  ) {}

  private getRedirectBackUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirectBack');
  }

  private tryRedirectBack() {
    const redirectBack = this.getRedirectBackUrl();
    if (redirectBack) {
      this.router.goTo(redirectBack);
      return true;
    }
    return false;
  }

  redirect = (page: string) => {};
  redirectInNavigation = (page: string) => {};

  boot = async () => {
    const {
      data: [currentUnitResult],
    } = await this.learningRootService.unitResult.search({
      filter: [
        { fieldName: 'userId', type: 'equal', value: this.ui.layoutDomain.entity.ui.activeUser.entity.id },
        { fieldName: 'unitId', type: 'equal', value: this.ui.passingId.value },
      ],
    });

    if (!currentUnitResult) {
      this.ui.layoutDomain.entity.notifications.showNotification({
        type: LayoutNotificationType.error,
        text: this.i18n.translate('phrases.failedToLoadUnitResults'),
      });
      return;
    }
    const currentUnit = await this.learningRootService.unit.getById(this.ui.passingId.value);

    const resultsValues: IFinalResultsValues = {
      quizResult: currentUnitResult.quizResult,
      theoryResult: currentUnitResult.theoryResult,
      practiceResult: currentUnitResult.practiceResult,
      totalUnitResult: currentUnitResult.totalUnitResult,
    };

    const resultPercentage = currentUnitResult.totalUnitResult / currentUnit.score;
    const correctQuizAnswersCount = resultsValues?.quizResult?.questions?.filter((item) => item.result).length || 0;
    const correctPracticeAnswersCount = resultsValues?.practiceResult?.tasks?.filter((item) => item.result).length || 0;
    const correctQuizMaximumScore = currentUnit?.quiz?.isEnabled ? currentUnit?.quiz?.questions?.length : 0;
    const correctPracticeMaximumScore = currentUnit?.practice?.isEnabled ? currentUnit?.practice?.tasks?.length : 0;

    this.ui.stepContent.setList([
      {
        component: (
          <FinalResultsVerbose
            finalResultsVerbose={
              this.ui.results?.entity?.[getResultStatus(resultPercentage, currentUnitResult.isPassed)]
            }
            correctQuizMaximumScore={correctQuizMaximumScore}
            correctPracticeMaximumScore={correctPracticeMaximumScore}
            correctQuizAnswersCount={correctQuizAnswersCount}
            correctPracticeAnswersCount={correctPracticeAnswersCount}
            maximumScore={currentUnit.score}
            totalUnitResult={resultsValues.totalUnitResult}
          />
        ),
        isEneble: true,
      },
    ]);
  };

  onRedirectTo = () => {
    if (!this.tryRedirectBack()) {
      this.router.goTo('/learning/user');
    }
  };
}